import { render, staticRenderFns } from "./OrgChartTemp4.vue?vue&type=template&id=2037f8ec&scoped=true&"
import script from "./OrgChartTemp4.vue?vue&type=script&lang=js&"
export * from "./OrgChartTemp4.vue?vue&type=script&lang=js&"
import style0 from "./OrgChartTemp4.vue?vue&type=style&index=0&id=2037f8ec&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2037f8ec",
  null
  
)

export default component.exports